<script setup>
import {computed, onMounted, ref} from "vue";
import _ from "lodash";

const props = defineProps({
    isDisabled: {
        type: Boolean,
        default: false
    },
    initialInput: {
        type: String,
        required: false,
    },
    voucherKey: {
        type: String,
        required: true,
    },
    voucherEventBus: {
        type: Object,
        required: true,
    },
})

const emit = defineEmits(['voucher-added', 'voucher-removed']);

const input = ref(props.initialInput);
const addText = window.Drupal.t('Add');
const removeText = window.Drupal.t('Remove');
const placeholderText = window.Drupal.t('CAMPAIGNCODE001');
const initialDisabled = ref(!_.isEmpty(props.initialInput));

const canRemove = computed(() => {
    return props.isDisabled || initialDisabled.value;
})

const handleClick = () => {
    if (_.isEmpty(input.value)) {
        return;
    }

    emit('voucher-added', input.value);
}

const handleRemove = () => {
    emit('voucher-removed', input.value);
}

onMounted(() => {
    props.voucherEventBus.$on('clear-input', (payload) => {
        if (!_.isEqual(payload, props.voucherKey)) {
            return
        }

        initialDisabled.value = false;
        input.value = '';
    })
})
</script>

<template>
    <div class="vue-voucher-input">
        <input type="text" v-model="input" :placeholder="placeholderText" :disabled="isDisabled || initialDisabled">
        <button v-if="!canRemove" @click="handleClick" :disabled="canRemove"><span class="visually-hidden">{{
                addText
            }}</span></button>
        <button v-if="canRemove" class="toggle-remove" @click="handleRemove"><span class="visually-hidden">{{
                removeText
            }}</span></button>
    </div>
</template>